import {UI} from "../../../../stem-core/src/ui/UIBase";

import {BaseTabAreaStyle, TabArea} from "../../../../stem-core/src/ui/tabs/TabArea";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {InlineUserDashboardSubscriptionTab} from "./tabs/InlineUserDashboardSubscriptionTab";
import {InlineUserDashboardDonationTab} from "./tabs/InlineUserDashboardDonationTab";
import {InlineUserDashboardNewslettersTab} from "./tabs/InlineUserDashboardNewslettersTab";
import {InlineUserDashboardAccountTab} from "./tabs/InlineUserDashboardAccountTab";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {PoweredByBlink} from "../../PoweredByBlink";
import {isSmallScreen} from "../../../UtilsLib";
import {iFrameState} from "../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../blink-sdk/Constants";
import {BasePanelPage, BasePanelPageStyle} from "../../PanelPage";


class TabAreaStyle extends BaseTabAreaStyle {
    @styleRuleInherit
    tab = () => ({
        padding: "12px 0",
        cursor: "pointer",
        fontSize: isSmallScreen() ? this.themeProps.MERCHANT_FONT_SIZE_SMALL : 18,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
        flex: 1,
        textAlign: "center",
        ...this.themeProps.MERCHANT_USER_DASHBOARD_TAB_STYLE,
    });

    @styleRuleInherit
    activeTab = {
        cursor: "default",
        backgroundColor: "",
        ...this.themeProps.MERCHANT_USER_DASHBOARD_ACTIVE_TAB_STYLE,
    };

    @styleRuleInherit
    nav = {
        display: "flex",
    };

    @styleRuleInherit
    tabArea = {
        width: "100%",
        background: this.themeProps.WHITE,
        maxWidth: 540,
        margin: isSmallScreen() ? 0 : "0 auto 12px",
        display: "flex",
        flex: 1,
        overflow: "auto",
        flexDirection: "column",
    };
}

class InlineUserDashboardStyle extends BasePanelPageStyle {
    @styleRuleInherit
    panelPage = {
        display: "flex",
        flexDirection: "column",
        maxHeight: "100% !important",
    };

    @styleRule
    tabAreaContainer = {
        flex: 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
    };

    @styleRuleInherit
    body = {
        flex: 1,
        overflow: "auto",
        ...(isSmallScreen() ? {
            padding: 0
        } : {
            padding: 18,
        })
    };

    @styleRule
    poweredByBlink = {
        display: isSmallScreen() ? "none" : "",
    }

    @styleRuleInherit
    frame = {
        flex: 1,
        overflow: "auto",
    }
}

@registerStyle(InlineUserDashboardStyle)
export class InlineUserDashboard extends BasePanelPage {
    widthValue = 960;
    heightValue = Math.min(780, this.getMaxHeight());

    getMaxHeight() {
        return iFrameState.screen.height;
    }

    getMaxWidth() {
        return iFrameState.screen.width;
    }

    render() {
        if (!this.tabArea) {
            const tabClasses = {
                [PANEL_TYPE.donation]: InlineUserDashboardDonationTab,
                ["donate"]: InlineUserDashboardDonationTab,
                [PANEL_TYPE.subscribe]: InlineUserDashboardSubscriptionTab,
                ["subscription"]: InlineUserDashboardSubscriptionTab,
                [PANEL_TYPE.newsletter]: InlineUserDashboardNewslettersTab,
                [PANEL_TYPE.authentication]: InlineUserDashboardAccountTab,
                ["identity"]: InlineUserDashboardAccountTab,
                ["account"]: InlineUserDashboardAccountTab,
            }
            const tabs = iFrameState.dashboardTabs.map(tabType => {
                const TabClass = tabClasses[tabType];
                if (!TabClass) {
                    return null;
                }
                return <TabClass />;
            });
            this.tabArea = <TabArea styleSheet={TabAreaStyle}>
                {tabs}
            </TabArea>;
        }
        const {styleSheet} = this;
        return [
            <div className={styleSheet.tabAreaContainer}>
                {this.tabArea}
                <PoweredByBlink className={styleSheet.poweredByBlink}/>
            </div>,
        ];
    }
}
